import { DFY_PACKAGE_CREDITS } from "@repo/api/utils/dfy-billing";
import { useDfyOrderStore } from "@/lib/stores/dfy-order-store/dfy-order-store";
import {
  DFY_PACKAGE_CONTENT,
  DFY_PACKAGE_EXAMPLES,
  DFY_PACKAGE_FEATURES,
  formatDfyCreditsToPrice,
} from "../dfy-order-form-content";
import { DfyStepProps } from "../dfy-order-form-steps";
import OptionCard from "../components/OptionCard";
import DfyStepHeader from "../components/DfyStepHeader";
import DfyStepNavigation from "../components/DfyStepNavigation";
import DfyExampleVideo from "../components/DfyExampleVideo";

export default function PackageStep({ onBack, onNext }: DfyStepProps) {
  const type = useDfyOrderStore((state) => state.order?.details.type);
  const updateDetails = useDfyOrderStore(
    (state) => state.service.updateDetails,
  );

  return (
    <>
      <DfyStepHeader
        title="Choose a package"
        description="Pick the size that fits your listing."
      />
      <div className="flex flex-col gap-8 py-6">
        <div className="flex flex-col gap-4">
          {DFY_PACKAGE_CONTENT.map((option) => (
            <OptionCard
              key={option.id}
              option={option}
              price={formatDfyCreditsToPrice(DFY_PACKAGE_CREDITS[option.id])}
              isSelected={type === option.id}
              control="checkbox"
              onToggle={() =>
                updateDetails((details) => {
                  details.type = option.id;
                })
              }
            />
          ))}
        </div>
        <div className="flex flex-col gap-3">
          <p className="text-sm font-medium">Examples</p>
          <div className="grid gap-4 sm:grid-cols-2">
            {DFY_PACKAGE_EXAMPLES.slice(0, 2).map((example) => (
              <DfyExampleVideo
                key={example.vimeoId}
                example={example}
                source="DFY_ORDER_FORM"
              />
            ))}
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <p className="text-sm font-medium">Included in every package</p>
          <ul className="flex flex-col gap-3 rounded-xl border px-5 py-4 text-sm text-text-primary">
            {DFY_PACKAGE_FEATURES.map(({ label, icon: Icon }) => (
              <li key={label} className="flex items-center gap-3">
                <Icon className="size-4 shrink-0" color="url(#icon-gradient)" />
                {label}
              </li>
            ))}
          </ul>
        </div>
        <DfyStepNavigation onBack={onBack} onNext={onNext} />
      </div>
    </>
  );
}
